<template>
  <div class="regisiterPop">
    <!-- v-slot="{ invalid }" -->
    <ValidationObserver ref="form" v-slot="{ handleSubmit }">
      <div class="loginPopContent">
        <!-- <div class="register_box">
          <img class="home_logo_img1" src="../../assets/image/Logo/logo1.png" alt />
          <img class="home_logo_img4" src="../../assets/image/Logo/home_side_bar_sdg.png" alt />
        </div>-->
        <div class="contents">
          <form @submit.prevent="onSubmit">
            <!-- <form @submit.prevent="handleSubmit(onSubmit)"> -->
            <div class="content_box">
              <div class="title_user">{{$t('User.Register.Register')}}</div>

              <div class="inputbox" :class="[language == 'en' ? 'en_indent' : 'zh_indent']">
                <div class="form_name">
                  <div>{{$t('User.Register.UserName')}} :</div>
                </div>

                <div class="form_input">
                  <ValidationProvider
                    vid="userName"
                   :name="$t('fields.userName')"
                    rules="userName|required"
                    v-slot="v"
                  >
                    <input
                      @blur="checkLoginName"
                      v-model="loginName"
                      type="text"
                      :placeholder="$t('User.Register.TipUserName')"
                    />
                    <span class="tip_validate">{{ v.errors[0] }}</span>
                  </ValidationProvider>
                </div>
              </div>

              <div class="inputbox" :class="[language == 'en' ? 'en_indent' : 'zh_indent']">
                <div class="form_name">
                  <div>{{$t('User.Register.Email')}} :</div>
                </div>

                <div class="form_input">
                  <ValidationProvider vid="email" :name="$t('fields.email')" rules="email|required" v-slot="v">
                    <input
                      @blur="checkEmail"
                      v-model="email"
                      type="text"
                      :placeholder="$t('User.Register.TipEmail')"
                    />
                    <span class="tip_validate">{{ v.errors[0] }}</span>
                    <div
                      class="getCode_class"
                      :class="[
                        v.passed ? 'activePassed' : 'noPassed',
                        !canClick ? 'noPassed' : 'activePassed',
                      ]"
                      @click="sendCode(v.passed)"
                    >{{ tip_time }}</div>
                  </ValidationProvider>
                </div>
              </div>

              <div class="inputbox marttop" :class="[language == 'en' ? 'en_indent' : 'zh_indent']">
                <div class="form_name">
                  <div>{{$t('User.Register.Code')}} :</div>
                </div>
                <div class="form_input">
                  <ValidationProvider vid="code" :name="$t('fields.code')" rules="code|required" v-slot="codeV">
                    <input
                      oninput="this.value=this.value.replace(/[^0-9]/g,'');"
                      maxlength="6"
                      v-model="code"
                      :placeholder="$t('User.Register.TipCode')"
                    />
                    <span class="tip_validate">{{ codeV.errors[0] }}</span>
                  </ValidationProvider>
                </div>
              </div>

              <div class="inputbox" :class="[language == 'en' ? 'en_indent' : 'zh_indent']">
                <div class="form_name">
                  <div>{{$t('User.Register.Password')}} :</div>
                </div>

                <div class="form_input">
                  <ValidationProvider :name="$t('fields.password')" rules="required|min" v-slot="v" vid="password">
                    <input
                      v-model="password"
                      type="password"
                     :placeholder="$t('User.Register.TipPassword')"
                      onkeypress="javascript:if(event.keyCode == 32)event.returnValue = false;"
                    />
                    <span class="tip_validate">{{ v.errors[0] }}</span>
                  </ValidationProvider>
                </div>
              </div>

              <div class="inputbox" :class="[language == 'en' ? 'en_indent' : 'zh_indent']">
                <div class="form_name">
                  <div>{{$t('User.Register.ConfirmPassword')}} :</div>
                </div>

                <div class="form_input">
                  <ValidationProvider :name="$t('fields.confirm')" rules="confirmed:password" v-slot="v">
                    <input
                      v-model="confirmPassword"
                      type="password"
                      :placeholder="$t('User.Register.TipConfirmPassword')"
                      onkeypress="javascript:if(event.keyCode == 32)event.returnValue = false;"
                    />
                    <span class="tip_validate">{{ v.errors[0] }}</span>
                  </ValidationProvider>
                </div>
              </div>

              <!--   :class="[handleSubmit ? 'abledClass' : 'disabledClass']" -->
              <div class="loginBtn" @click="registerFun(handleSubmit)">{{$t('User.Register.Register')}}</div>
              <div class="register">
                <div @click="login()">{{$t('User.Register.Login')}}</div>|
                <div @click="forget()">{{$t('User.Register.Forget')}}</div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </ValidationObserver>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { mapMixin } from "@/util/mixin";
import {
  Signup,
  EmailCode,
  checkLoginNameUnique,
  checkEmailUnique
} from "@/axios/api";
import { userLogin, checkJwt } from "@/axios/api";
import bus from "@/bus";


export default {
  mixins: [mapMixin],
  data() {
    return {
      loginName: "",
      email: "",
      password: "",
      confirmPassword: "",
      timer: null,
      time: 60,
      code: null,
      tip_time: "",
      canClick: true, //添加canClick
      email: null
    };
  },
  mounted() {
    this.tip_time = this.$t("register.getCode");
  },
  components: {
    ValidationProvider,
    ValidationObserver
  },
  methods: {
    async getEmailCode() {
      var res = await EmailCode(this.email);
    },
    forget() {
      this.$router.push("/forget");
    },
    registerFun(val) {
      this.$refs.form.validate().then(success => {
        if (!success) {
          return;
        }
        this.getSignup();
      });
    },
    async getSignup() {
      // return
      var param = {
        password: this.$md5(this.password),
        confirmPassword: this.$md5(this.confirmPassword),
        email: this.email,
        loginName: this.loginName,
        activeCode: this.code
      };
      var res = await Signup(param);

      if (res.status == 200) {
        if (res.data.code == 10003) {
          this.$refs.form.setErrors({
            code: [res.data.msg]
          });
          return false;
        }
        if (res.data.status == 0) {
          return false;
        } else {
          this.tipFun(res.data.msg);
          this.loginName = "";
          this.email = "";
          this.password = "";
          this.confirmPassword = "";
          this.code = "";
          this.$message({
            duration: 1000,
            type: "success",
            message: this.$t('Verification.OK'),
            center: true
          });
          this.login();
        }
      }
    },
    tipFun(val) {
   
    },
    login() {
      this.$router.push("/login");
    },
    sendCode(bool) {
      if (!bool) {
        return;
      }

      if (!this.canClick) return;
      this.checkEmailUniqueFun();
    },
    checkLoginName() {
      this.checkLoginNameUniqueFun();
    },

    async checkEmail() {
      var res = await checkEmailUnique(this.email);
      if (res.data.code == 404) {
        this.$refs.form.setErrors({
          email: [res.data.msg == '邮箱已注册'?this.$t('Verification.EmailRegistered'):this.$t('Verification.EmailErr')]
        });
      }
    },

    // 校验用户名
    async checkLoginNameUniqueFun() {
      var res = await checkLoginNameUnique(this.loginName);
      if (res.data.code == 404) {
        this.$refs.form.setErrors({
          userName: [ res.data.msg == "用户名已注册"?this.$t('Verification.UserNameRegistered'):this.$t('Verification.UserNameRegistered')]
        });
      }
    },
    // 校验邮箱
    async checkEmailUniqueFun() {
      var res = await checkEmailUnique(this.email);

      if (res.data.code == 404) {
        window.clearInterval(this.timer);
        this.time = 60;
        this.tip_time =this.$t('Verification.getCode');
        this.canClick = true;
      } else {
        this.getEmailCode();
        this.countDown();
      }
    },
    // 倒计时
    countDown() {
      var that = this;
      if (!this.canClick) return;
      this.canClick = false;
      this.timer = window.setInterval(() => {
        this.time--;
        this.tip_time = this.time + "S";
        if (this.time < 0) {
          window.clearInterval(this.timer);
          this.time = 60;
          this.tip_time = this.$t('Verification.getCode');
          this.canClick = true;
        }
      }, 1000);
    },
    closeRegisterPop() {
      bus.$emit("closeRegisterPopshow");
    }
  },
watch: {
    language(){
       this.$router.go(0) 
    }
  },
};
</script>

<style lang="scss" scoped>
.regisiterPop {
  background: #fff;
  padding: 10px 0;
  width: 100%;
  .loginPopContent {
    padding-top: 20px;
    background-size: 100% 100%;
    margin: auto;
    .contents {
      margin-bottom: 20px;
      .content_box {
        opacity: 0.7;
        padding: 20px 30px;
        .title_user {
          text-align: center;
          color: #000;
          font-size: 22px;
          margin-bottom: 20px;
          font-weight: 600;
        }
      }
      .inputbox {
        position: relative;
        display: flex;
        flex-direction: row;
        align-items: center;
        border: 1px solid #666;
        border-radius: 4px;
        padding: 0px 10px;
        height: 48px;
        line-height: 48px;
        margin-bottom: 42px;
        .form_name {
          min-width: 90px;
          text-align: left;
          color: #666;
          font-size: 16px;
        }
        .form_input {
          // position: relative;
          flex: 1;
          input {
            background: transparent;
            border: none;
            width: 100%;
            outline: none;
            color: #000;
            font-size: 16px;
          }
          .tip_validate {
               position: absolute;
    top: 50px;
    line-height: 16px;
    left: 10px;
    font-size: 14px;
    color: #ac233f;
          }
        }
      }
      .register {
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 14px;
        div {
          margin: 20px 20px;
          cursor: pointer;
          color: #999;
          &:hover {
            color: #0057aa;
          }
        }
      }
    }
  }
}
.code {
  position: relative;
}
.code input {
  width: 70% !important;
  display: flex;
}
.code div {
  box-shadow: 0px 2px 5px #000;
  color: rgba(7, 58, 119, 1) !important;
  background-color: #fff;
  position: absolute;
  right: 0px;
  line-height: 42px;
  text-align: center;
  top: 0;
  // background: rgba(255,255,255,.6);
  cursor: pointer;
  width: 25%;
  height: 42px;
  font-size: 14px;
  border: 1px solid rgba(7, 58, 119, 1);
  border-radius: 25px;
}

.code div:hover {
  background: rgba(255, 255, 255, 0.5);
}

.NoBtn_ {
  // background: rgba(255, 255, 255, 0.4);
  color: rgba(255, 255, 255, 0.4) !important;
  cursor: not-allowed !important;
}
.img_login {
  position: absolute;
  top: 30px;
  left: 50%;
  margin-left: -115px;
  width: 230px;
}

.getCode_class {
  position: absolute;
  cursor: pointer;
  transition: 0.2s;
  margin-top: 42px;
  right: 10px;
  text-align: right;
  z-index: 11;
}
.activePassed {
  color: #1a73e8 !important;
}
.noPassed {
  color: #666 !important;
  cursor: not-allowed;
}
.getCode_class:hover {
  opacity: 0.8;
  transition: 0.2s;
}
.loginBtn {
  // box-shadow: 0px 2px 4px #020920;
  margin-top: 20px;
  width: 100%;
  height: 48px;
  line-height: 48px;
  border-radius: 4px;
  text-align: center;
  color: #fff;
  font-size: 16px;
  cursor: pointer;
  background: linear-gradient(
    to right,
    rgba(0, 167, 220, 1),
    rgba(0, 87, 170, 1)
  );
  transition: 0.2s;
}
.loginBtn:hover {
  transition: 0.2s;
  background: linear-gradient(
    to right,
    rgba(0, 135, 255, 0.6),
    rgba(0, 87, 170, 0.6)
  ); /* 标准的语法 */
}
.disabledClass {
  transition: 0.2s;
  background: linear-gradient(
    to right,
    rgba(0, 167, 220, 1),
    rgba(0, 87, 170, 1)
  ); /* 标准的语法 */
}
.abledClass {
  transition: 0.2s;
  background: #ccc !important;
  cursor: not-allowed !important;
}
.loginBtn:hover {
  transition: 0.2s;
  background: linear-gradient(
    to right,
    rgba(0, 135, 255, 0.6),
    rgba(0, 87, 170, 0.6)
  ); /* 标准的语法 */
}
.register_box {
  margin-top: 30px;
  text-align: center;
  .home_logo_img4 {
    width: 70px;
    height: 70px;
    margin-right: 20px;
  }
  .home_logo_img1 {
    width: 126px;
    height: 70px;
    margin-right: 20px;
  }
}
</style>